import PatientsBillsList from "../PatientBillsList/PatientsBillsList";
import PaymentsOverview from "../PaymentsOverview/PaymentsOverview";

export default function PaymentTabWrapper() {
    return (
        <div>
            <PaymentsOverview />
            <PatientsBillsList />
        </div>
    );
}
